import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconWrapper, Box, Icon, Copy, Media } from '@honda-canada/design-system-react';
import Loader from '../../../../../utils/components/Loader';
import themeStyles from '../DealerInventoryModal.styles';
import useFetchDealerInventory from '../useFetchDealerInventory';
import DealerInventoryList from './DealerInventoryList';
import DealerInventoryTable from './DealerInventoryTable';
import useFetchDealerAvailability from '../../../../../core/apiHooks/dealer_inventory/useFetchDealerAvailabilty';
import { HONDA_PAYMENT_GATEWAY } from '../../../../../utils/constants';
import useSharedApps from '../../../../../utils/sitecoreContext/useSharedApps';
import useExcludedDealers from '../../../../../utils/sitecoreContext/useExcludedDealers';
const ErrorWrapper = themeStyles.apply(Box, 'ErrorWrapper');
const DealerInventoryModalContent = ({ isProvince, setCurrentDealer, modelCode, gtmTagging }) => {
    const { t } = useTranslation();
    const paymentUrl = useSharedApps(HONDA_PAYMENT_GATEWAY);
    const { isFetching, hasError, data } = useFetchDealerInventory(isProvince);
    const excludedDealers = (useExcludedDealers() || '').split(';');
    const { data: availability, isFetching: fetchingAvailability } = useFetchDealerAvailability(modelCode, data === null || data === void 0 ? void 0 : data.map(({ dealerCode }) => dealerCode));
    const filteredAvailability = {};
    // eslint-disable-next-line array-callback-return
    Object.entries(availability || {}).map(dealerAvailability => {
        if (excludedDealers.includes(dealerAvailability[0])) {
            filteredAvailability[dealerAvailability[0]] = false;
        }
        else {
            filteredAvailability[dealerAvailability[0]] = dealerAvailability[1];
        }
    });
    if (isFetching || fetchingAvailability)
        return React.createElement(Loader, { horizontalAlignment: "center", testId: "loading", isLargeIcon: true });
    if (hasError)
        return (React.createElement(ErrorWrapper, null,
            React.createElement(IconWrapper, { size: "iconWrapper.zero" },
                React.createElement(Icon, { name: "information", filled: true })),
            React.createElement(Copy, { "data-testid": "error-message", size: "extraSmall" }, t('Shared.Common.invModalNoDealersLabel'))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Media, { lessThan: "desktop" },
            React.createElement(DealerInventoryList, { availability: filteredAvailability, data: data, paymentUrl: paymentUrl, modelCode: modelCode, gtmTagging: gtmTagging })),
        React.createElement(Media, { greaterThanOrEqual: "desktop" },
            React.createElement(DealerInventoryTable, { setCurrentDealer: setCurrentDealer, availability: filteredAvailability, data: data, paymentUrl: paymentUrl, modelCode: modelCode, gtmTagging: gtmTagging }))));
};
export default DealerInventoryModalContent;
